/**
 * BgCircuitTrace — Circuit board traces appearing progressively
 * Registro: developer/código/automação — cenas de sistema, pipeline, terminal
 * Paleta: teal traces em near-black, nós pulsantes
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig} from "remotion";


interface BgCircuitTraceProps {
  /** Cor das trilhas (default: teal) */
  traceColor?: string;
  /** Velocidade de aparecimento (default: 1) */
  speed?: number;
  /** Opacidade máxima das trilhas 0–1 (default: 0.2) */
  maxOpacity?: number;
}

export const BgCircuitTrace: React.FC<BgCircuitTraceProps> = ({
  traceColor = "#14B8A6",
  speed = 1,
  maxOpacity = 0.2,
}) => {
  const f = useCurrentFrame();
  const {fps} = useVideoConfig();
  const t = (f / fps) * speed;

  // Circuit segments: horizontal + vertical traces at fixed grid positions
  const hTraces = [
    {y: 15, x1: 5,  x2: 35, delay: 0.2},
    {y: 15, x1: 40, x2: 65, delay: 0.8},
    {y: 30, x1: 20, x2: 80, delay: 0.4},
    {y: 45, x1: 5,  x2: 45, delay: 1.2},
    {y: 45, x1: 55, x2: 90, delay: 0.6},
    {y: 62, x1: 15, x2: 55, delay: 1.5},
    {y: 62, x1: 60, x2: 85, delay: 0.9},
    {y: 78, x1: 10, x2: 70, delay: 1.8},
    {y: 90, x1: 25, x2: 75, delay: 2.0},
  ];
  const vTraces = [
    {x: 35, y1: 15, y2: 30, delay: 0.5},
    {x: 65, y1: 15, y2: 30, delay: 1.0},
    {x: 20, y1: 30, y2: 45, delay: 0.7},
    {x: 45, y1: 45, y2: 62, delay: 1.3},
    {x: 55, y1: 45, y2: 62, delay: 0.3},
    {x: 70, y1: 62, y2: 78, delay: 1.6},
  ];

  // Nodes at intersections
  const nodes = [
    {x: 35, y: 15}, {x: 65, y: 15}, {x: 20, y: 30}, {x: 80, y: 30},
    {x: 45, y: 45}, {x: 55, y: 45}, {x: 15, y: 62}, {x: 70, y: 62},
    {x: 10, y: 78}, {x: 70, y: 78},
  ];

  return (
    <AbsoluteFill style={{background: "#060A0A", overflow: "hidden"}}>
      <svg style={{position: "absolute", inset: 0, width: "100%", height: "100%"}}>
        {hTraces.map((tr, i) => {
          const progress = Math.min(1, Math.max(0, (t - tr.delay) * 1.5));
          const x2 = tr.x1 + (tr.x2 - tr.x1) * progress;
          return (
            <line key={`h${i}`}
              x1={`${tr.x1}%`} y1={`${tr.y}%`}
              x2={`${x2}%`} y2={`${tr.y}%`}
              stroke={traceColor}
              strokeWidth={0.8}
              strokeOpacity={maxOpacity}
            />
          );
        })}
        {vTraces.map((tr, i) => {
          const progress = Math.min(1, Math.max(0, (t - tr.delay) * 1.5));
          const y2 = tr.y1 + (tr.y2 - tr.y1) * progress;
          return (
            <line key={`v${i}`}
              x1={`${tr.x}%`} y1={`${tr.y1}%`}
              x2={`${tr.x}%`} y2={`${y2}%`}
              stroke={traceColor}
              strokeWidth={0.8}
              strokeOpacity={maxOpacity}
            />
          );
        })}
        {nodes.map((n, i) => {
          const pulse = 0.4 + Math.sin(t * 2 + i * 0.7) * 0.3;
          const appeared = Math.min(1, Math.max(0, t - 0.3 - i * 0.15));
          return (
            <circle key={`n${i}`}
              cx={`${n.x}%`} cy={`${n.y}%`}
              r={3} fill={traceColor}
              opacity={appeared * pulse * maxOpacity * 1.5}
            />
          );
        })}
      </svg>
      {/* Ambient teal glow */}
      <div style={{
        position: "absolute", left: "30%", top: "35%",
        width: "55%", height: "55%",
        transform: "translate(-50%,-50%)",
        background: `radial-gradient(circle, ${traceColor}10 0%, transparent 70%)`,
        filter: "blur(70px)",
      }}/>
      <div style={{
        position: "absolute", inset: 0,
        background: "radial-gradient(ellipse at 50% 50%, transparent 45%, rgba(0,0,0,0.80) 100%)",
        pointerEvents: "none",
      }}/>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
